import { Link } from "react-router-dom";

const MAIN_SITE = "https://www.opusbusinessoperations.com";

const NAV_LINKS = [
  { label: "Home", href: `${MAIN_SITE}/`, external: true },
  { label: "About", href: `${MAIN_SITE}/about`, external: true },
  { label: "Services & Approach", href: `${MAIN_SITE}/services`, external: true },
  { label: "Resources", href: "/", external: false, active: true },
];

export default function Header({ overlay = false }) {
  return (
    <header
      data-testid="site-header"
      className={overlay ? "absolute top-0 left-0 right-0 z-20" : "relative z-20"}
      style={{
        background: overlay ? "transparent" : "var(--opus-sage)",
        color: "var(--opus-white)",
      }}
    >
      <div className="px-6 md:px-10 py-5">
        <nav className="flex items-center gap-6 md:gap-10 text-[0.72rem] md:text-[0.78rem] tracking-[0.25em] uppercase font-body flex-wrap">
          {NAV_LINKS.map((link) => (
            link.external ? (
              <a
                key={link.label}
                href={link.href}
                data-testid={`nav-${link.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="transition-opacity hover:opacity-70"
                style={{ color: "var(--opus-white)", opacity: link.active ? 1 : 0.85 }}
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.href}
                data-testid={`nav-${link.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="transition-opacity hover:opacity-70"
                style={{
                  color: "var(--opus-white)",
                  borderBottom: link.active ? "1px solid rgba(255,255,255,0.7)" : "none",
                  paddingBottom: link.active ? "2px" : 0,
                }}
              >
                {link.label}
              </Link>
            )
          ))}
        </nav>
      </div>
    </header>
  );
}
